/* eslint-disable no-debugger */
/* eslint-disable no-dupe-else-if */
/* eslint-disable react/jsx-key */
/* eslint-disable react-hooks/rules-of-hooks */

import React, { useState, useRef } from "react";
import { Button, Stack, Typography } from "@mui/material";
import {
  BootstrapActions,
  BootstrapContent,
  BootstrapDialog,
  BootstrapDialogTitle,
} from "../../components/dialog";
import { useTranslation } from "react-i18next";
import ZkSelect from "@/components/ZKSelect";
import { useFormik } from "formik";
import * as Yup from "yup";
import LoadingButton from "@mui/lab/LoadingButton";
import { editAdvGroup } from "@/services/DeviceService";
import { useSnackbar } from "notistack";

function AdvGroup(props) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { open, setOpen, rowId, allSelectedRows, screenDevice, loadData } =
    props;
  const [loading, setLoading] = useState(false);

  const options = [];
  for (let i = 2; i <= 65536; i *= 2) {
    options.push({ label: i.toString(), value: i.toString() });
  }
  const selectedDeviceIds = allSelectedRows?.map((row) => Object.keys(row)[0]);

  // 表单定义
  const advGroundFormik = useFormik({
    initialValues: {
      deviceIdList: [],
      advGroup: "",
    },
    onSubmit: (values, { setErrors, setStatus, setSubmitting }) => {
      try {
        let deviceIdList = [];
        deviceIdList.push(rowId);
        let params = {
          ...values,
          deviceIdList: screenDevice == "2" ? selectedDeviceIds : deviceIdList,
          deviceType: screenDevice == "2" ? 2 : 1,
        };
        setLoading(true);
        editAdvGroup(params).then((res) => {
          if (res?.data?.code == "LVLI0000") {
            setOpen(false);
            enqueueSnackbar(res?.data?.message, {
              variant: "success",
            });
            loadData();

            advGroundFormik.resetForm();
            setLoading(false);
          } else {
            enqueueSnackbar(res?.data?.message, {
              variant: "error",
            });
            setOpen(false);
            setLoading(false);
          }
        });
        setStatus({ success: false });
        setSubmitting(false);
      } catch (err) {
        setStatus({ success: false });
        setErrors({ submit: err.message });
        setSubmitting(false);
        setLoading(false);
      }
    },
    validationSchema: Yup.object().shape({
      advGroup: Yup.string().required(
        t("common.prompt") + ":" + t("gateway.ground_value")
      ),
    }),
  });

  return (
    <React.Fragment>
      <BootstrapDialog open={open} fullWidth onClose={() => setOpen(false)}>
        <form noValidate onSubmit={advGroundFormik.handleSubmit}>
          <BootstrapDialogTitle onClose={() => setOpen(false)}>
            <Typography variant="h5" component="p">
              {t("tips_gateway.adv_ground")}
            </Typography>
          </BootstrapDialogTitle>
          <BootstrapContent>
            <ZkSelect
              label={t("tips_gateway.adv_ground")}
              required
              name="advGroup"
              isClear={false}
              options={options}
              placeholder={t("gateway.enter_change")}
              value={advGroundFormik.values.advGroup}
              error={
                advGroundFormik.touched.advGroup &&
                Boolean(advGroundFormik.errors.advGroup)
              }
              helperText={
                advGroundFormik.touched.advGroup &&
                advGroundFormik.errors.advGroup
              }
              onChange={(e) => {
                advGroundFormik.setFieldValue("advGroup", e.target.value);
              }}></ZkSelect>
          </BootstrapContent>
          <BootstrapActions>
            <Stack spacing={1} direction="row">
              <Button
                color="info"
                variant="outlined"
                onClick={() => setOpen(false)}>
                {t("common.cancel")}
              </Button>
              <LoadingButton
                type="submit"
                loading={loading}
                variant="contained"
                color="primary"
                disableElevation>
                {t("common.ok")}
              </LoadingButton>
            </Stack>
          </BootstrapActions>
        </form>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default AdvGroup;
